import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
	color_333333,
	color_666666,
	color_999999,
	color_EDEEF1,
	color_F1F1F1,
	color_main,
	ColorF5F5F5,
	white,
} from '../../assets/style/colors';
import { isIOS } from '../../utils/utils';

export const chatStyles = StyleSheet.create({
	page: {
		margin: 0,
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		flexGrow: 1,
		height: '100%',
		width: '100%',
		backgroundColor: white,
	},
	item: {
		paddingTop: 0,
		paddingBottom: 0,
		margin: 0,
		position: 'relative',
	},
	top_item: {
		paddingTop: 0,
		paddingBottom: 0,
		margin: 0,
		position: 'relative',
		backgroundColor: color_F1F1F1,
	},
	itemContent: {
		height: 72,
		paddingRight: 70,
	},
	avatar: {
		width: 48,
		height: 48,
	},
	title: {
		fontSize: 16,
		color: color_333333,
	},
	subTitle: {
		fontSize: 12,
		color: color_999999,
		marginTop: 3,
	},
	timer: {
		position: 'absolute',
		right: 0,
		top: '50%',
		marginTop: -16,
		color: color_999999,
		fontSize: 12,
	},
	mute: {
		position: 'absolute',
		right: 0,
		top: '80%',
		marginTop: -16,
		color: color_999999,
		fontSize: 12,
	},
	chatView: {
		flex: 1,
		backgroundColor: white,
	},
	flatList: {
		flexGrow: 1,
		justifyContent: 'flex-end',
		paddingTop: 20,
		paddingBottom: 10,
	},
	flatListRow: {
		flexDirection: 'row',
		alignContent: 'center',
		justifyContent: 'center',
	},
	messageSelectBox: {
		justifyContent: 'center',
		alignContent: 'center',
	},
	messageSelect: {
		width: 16,
		display: 'flex',
		height: 16,
		borderRadius: 8,
		borderWidth: 1,
		borderColor: '#eeeeee',
		marginLeft: 5,
		marginTop: 18,
		// backgroundColor: 'pink',
		justifyContent: 'center',
		alignContent: 'center',
	},
	selected: {
		color: '#ffffff',
		backgroundColor: '#6189FF',
		justifyContent: 'center',
		alignContent: 'center',
	},
	selectedIcon: {
		marginLeft: -1,
		marginTop: -3,
	},
	tools: {
		display: 'flex',
		height: 100,
		zIndex: 20,
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-around',
		alignItems: 'center',
		bottom: 0,
		backgroundColor: '#ffffff',
		borderTopWidth: 1,
		borderColor: '#D5D9DF',
	},
	toolsOk: {
		width: 30,
		height: 30,
		justifyContent: 'center',
		alignItems: 'center',
	},

	// 头部滚动导航
	navSlider: {
		height: 48,
		overflow: 'hidden',
		backgroundColor: '#ffffff',
		width: '100%',
		borderBottomWidth: 1,
		borderColor: '#D5D9DF',
	},
	// 会话列表
	sectionList: {
		height: '100%',
	},
	navText: {
		fontSize: 13,
		lineHeight: 42,
		height: 42,
		paddingHorizontal: 10,
		color: '#999999',
	},
	navTextOn: {
		color: 'rgba(57, 102, 238, 1)',
		fontWeight: 'bold',
		fontFamily: '',
	},
});

export const chatInputStyles = StyleSheet.create({
	inputView: {
		borderTopWidth: 1,
		borderTopColor: color_EDEEF1,
		paddingBottom: 30,
	},
	inputTarget: {
		fontSize: 16,
		backgroundColor: white, // 与聊天内容背景色一致
		color: color_333333,
		height: 160, // 固定高度
		paddingVertical:  8,
		borderRadius: 6,
		paddingHorizontal: 12,
	},
	icons: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingVertical: 8,
		alignItems: 'center',
		paddingHorizontal: 12,
	},
	iconItem: {
		width: 32,
		height: 32,
		color: color_666666,
	},
	activeIcon: {
		color: color_main,
	},
	memberSyncOverlay: {
		flex: 1,
		backgroundColor: white,
		alignItems: 'center',
		justifyContent: 'center',
	},
	memberSyncOverlayText: {
		marginTop: 16,
		fontSize: 15,
		color: color_333333,
	},
	memberSyncOverlayError: {
		fontSize: 14,
		color: '#E53935',
		textAlign: 'center',
		paddingHorizontal: 32,
		marginBottom: 20,
	},
	memberSyncRetryBtn: {
		paddingHorizontal: 32,
		paddingVertical: 10,
		backgroundColor: color_main,
		borderRadius: 20,
	},
	memberSyncRetryText: {
		fontSize: 15,
		color: white,
	},
});

export const topicModalStyles = StyleSheet.create({
	header: {
		display: 'flex',
		backgroundColor: white,
		height: 42,
	},
	headerIcon: {
		position: 'absolute',
		left: 16,
		top: 8,
		zIndex: 2,
	},
	headerTitle: {
		width: '100%',
		textAlign: 'center',
		color: color_333333,
		fontSize: 16,
		lineHeight: 42,
		fontWeight: 'bold',
		fontFamily: '',
	},
});
